import { combineReducers } from "redux"

const main = function reducer(
	state={
		restaurants: [],
		prices: [],
		areas: [],
		restaurantsSelected: [],
		areasSelected: null,
		pricesSelected: null,
		displayType: 'grid',
	},
	action
) {
	switch(action.type) {

		case 'DEFAULTS': {
			return { ...state,
				restaurants: action.payload.restaurants,
				prices: action.payload.prices,
				areas: action.payload.areas,
			}
		}

		case 'AREA_SELECTED': {
			return { ...state,
				areasSelected: action.payload.areasSelected,
			}
		}

		case 'PRICE_SELECTED': {
			return { ...state,
				pricesSelected: action.payload.pricesSelected,
			}
		}

		case 'FILTER_RESULTS': {
			return { ...state,
				restaurantsSelected: action.payload.restaurantsSelected,
			}
		}

		case 'DISPLAY_RESULTS': {
			return { ...state,
				displayType: action.payload.displayType,
			}
		}

		default : {
			return { ...state}
		}
	}
}





export default combineReducers({
	main
})


// WEBPACK FOOTER //
// ./src/reducer.js